// frontend/src/components/auth/TenantRedirect.js
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { tenantNameToSlug } from '../../utils/tenantSlug';

const TenantRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (user && user.tenant_name) {
      const urlFriendlyTenantName = tenantNameToSlug(user.tenant_name);
      const path = location.pathname.replace('/dashboard', '');
      navigate(`/${urlFriendlyTenantName}${path}`, { replace: true });
    } else if (user && !user.tenant_name && location.pathname.startsWith('/dashboard')) {
      navigate('/select-tenant', { replace: true });
    }
  }, [user, navigate, location]);

  return null;
};

export default TenantRedirect;